// extracted by mini-css-extract-plugin
export default {"addOnThumbnail":"AddOnsList_addOnThumbnail__aOO6d"};